import { j as json, e as error } from "../../../../../../chunks/index2.js";
import admin from "firebase-admin";
import { g as getUserDataPath } from "../../../../../../chunks/utils.js";
import { G as GITHUB_USER } from "../../../../../../chunks/private.js";
import { o as octokit } from "../../../../../../chunks/octokit.js";
import { d as delay } from "../../../../../../chunks/utils2.js";
const getWorkflowJob = async (workflowId) => {
  const jobs = await octokit.rest.actions.listJobsForWorkflowRun({
    owner: GITHUB_USER,
    repo: "glimmr",
    run_id: workflowId,
    filter: "latest"
  });
  return jobs.data.jobs[0];
};
const waitUntilWorkflowInProgress = async (branch, waitDuration = 5e3) => {
  const workflows = await octokit.rest.actions.listWorkflowRuns({
    owner: GITHUB_USER,
    repo: "glimmr",
    branch,
    workflow_id: "main.yml",
    status: "in_progress"
  });
  const workflow = workflows.data.workflow_runs[0];
  if (workflow) {
    return workflow;
  }
  await delay(waitDuration);
  return waitUntilWorkflowInProgress(branch, waitDuration);
};
const pollWorkflowJob = async (jobId, onUpdate, waitDuration = 5e3) => {
  const job = await octokit.rest.actions.getJobForWorkflowRun({
    owner: GITHUB_USER,
    repo: "glimmr",
    job_id: jobId
  });
  onUpdate(job.data);
  if (job.data.status === "completed") {
    return job.data;
  }
  await delay(waitDuration);
  return pollWorkflowJob(jobId, onUpdate, waitDuration);
};
const triggerWorkflow = (branch, access) => {
  return octokit.rest.actions.createWorkflowDispatch({
    workflow_id: "main.yml",
    repo: "glimmr",
    owner: GITHUB_USER,
    ref: branch,
    inputs: {
      access
    }
  });
};
const updateInstallerProgress = (email, data) => admin.firestore().collection("installers").doc(email).set(data, { merge: true });
const beginDownload = async (user) => {
  try {
    const usersByEmail = await admin.firestore().collection("users").where("email", "==", user.email).get();
    const licenseSnapshot = await admin.firestore().collection("licenses").doc(user.email).get();
    const license = licenseSnapshot.data();
    const ids = usersByEmail.docs.map((doc) => doc.data()).map((data2) => data2.id);
    const userDataPath = await getUserDataPath(license?.code);
    const branch = `user/${user.email}`;
    const { data } = await octokit.rest.repos.getCommit({
      owner: GITHUB_USER,
      repo: "glimmr",
      ref: "refs/heads/main"
    });
    await octokit.rest.git.deleteRef({
      owner: GITHUB_USER,
      repo: "glimmr",
      ref: `heads/${branch}`
    });
    await octokit.rest.git.createRef({
      owner: GITHUB_USER,
      repo: "glimmr",
      ref: `refs/heads/${branch}`,
      sha: data.sha
    });
    await triggerWorkflow(branch, ids.join(","));
    const workflow = await waitUntilWorkflowInProgress(branch);
    const job = await getWorkflowJob(workflow.id);
    await pollWorkflowJob(job.id, (job2) => {
      const completed = job2.steps?.filter((step) => step.status === "completed").length;
      const total = job2.steps?.length;
      const progress = `${completed} / ${total}`;
      updateInstallerProgress(user.email, {
        progress
      });
    });
    const artifacts = await octokit.rest.actions.listWorkflowRunArtifacts({
      owner: GITHUB_USER,
      repo: "glimmr",
      run_id: workflow.id
    });
    const artifact = artifacts.data.artifacts[0];
    await updateInstallerProgress(user.email, {
      status: "complete",
      artifactId: artifact.id
    });
  } catch (err) {
    await updateInstallerProgress(user.email, {
      status: "error"
    });
  }
};
const GET = async ({ locals }) => {
  if (locals.user) {
    await admin.firestore().collection("installers").doc(locals.user.email).set({
      status: "pending"
    });
    beginDownload(locals.user);
    return json({
      success: true
    });
  }
  return error(403, { message: "Unauthorized" });
};
export {
  GET
};
